// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgIconRankGold = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={192}
    height={192}
    viewBox="0 0 192 192"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.36 96H96v5.64L29.64 168H24v-5.64L90.36 96Zm-49.08 72h11.255L96 124.534V113.28L41.28 168Zm33.64 0H63.6L96 135.6v11.32L74.92 168ZM96 168v-10.08L85.92 168H96Zm-72-17.28v-11.254L67.466 96H78.72L24 150.72Zm0-33.64v11.32L56.4 96H45.08L24 117.08ZM34.08 96 24 106.08V96h10.08ZM96 101.64V96h5.64L168 162.36V168h-5.64L96 101.64Zm72 49.08v-11.254L124.534 96H113.28L168 150.72Zm0-33.64v11.32L135.6 96h11.32L168 117.08ZM168 96h-10.08L168 106.08V96Zm-17.28 72h-11.254L96 124.535V113.28L150.72 168Zm-33.64 0h11.32L96 135.6v11.32L117.08 168ZM96 157.92 106.08 168H96v-10.08Z"
      fill="#fff"
    />
    <g clipPath="url(#clip0_2633_1239)">
      <path d="M24.026 96C25.07 56.72 56.72 25.07 96 24.027V96H24.026Z" fill="#fff" />
    </g>
    <g clipPath="url(#clip1_2633_1239)">
      <path d="M96 24.026C135.28 25.07 166.93 56.72 167.973 96H96V24.026Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="clip0_2633_1239">
        <path fill="#fff" transform="rotate(-90 60 36)" d="M0 0h72v72H0z" />
      </clipPath>
      <clipPath id="clip1_2633_1239">
        <path fill="#fff" transform="translate(96 24)" d="M0 0h72v72H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgIconRankGold.displayName = 'SvgIconRankGold'
const Memo = memo(SvgIconRankGold)
export { Memo as SvgIconRankGold }
